module.exports = "<div class=\"full-height-minus-search\">\n  <idap-property-filters\n  (onFilter)=\"onFilterChanged.next($event)\"\n  [properties]=\"properties\"></idap-property-filters>\n  <div class=\"sh-message\">\n    * Indicates a Student Housing property and calculations are per bed\n  </div>\n  <idap-property-table [properties]=\"filteredProperties\"\n  (onPropertySelected)=\"propertySelected($event)\"></idap-property-table>\n  <div propertyDetailPopupAnchor></div>\n  <div leaderboardAnchor></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/views/property-view.component.html
// module id = ./src/app/main/views/property-view.component.html
// module chunks = main